import { CHARACTER_LIMIT } from "../../../../constants";

export default function MessageLimit() {

    return (
        <div className="character-limit">Character limit exceeded. (Max {CHARACTER_LIMIT} character)</div>
    );
};
